module.exports = __webpack_public_path__ + "static/media/neutralFace.a415c879.png";